import { render } from "./LbrxDetailPopup.vue?vue&type=template&id=6c86f87f&scoped=true"
import script from "./LbrxDetailPopup.vue?vue&type=script&lang=js"
export * from "./LbrxDetailPopup.vue?vue&type=script&lang=js"

import "./LbrxDetailPopup.vue?vue&type=style&index=0&id=6c86f87f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c86f87f"]])

export default __exports__